import React, { useContext } from "react";
import { defined } from "../utilities/typeHelper";

export interface NotificationContextType {
  notification?: Notification;
  notificationError?: Notification;
  sendNotification: (text: string, autoHideDuration?: number) => void;
  sendNotificationError: (text: string, autoHideDuration?: number) => void;
}

export interface Notification {
  text: string;
  autoHideDuration: number;
}

export const NotificationContext = React.createContext<NotificationContextType | undefined>(undefined);

export const useNotificationContext = () => {
  const client = useContext(NotificationContext);
  return defined(client);
};
